import { snackbarTypes } from "../../../../util/state/globalVariables";
import { commonPricingIntegrationErrorsManagement } from "../../utils";

/**
 * Handle errors of CheckIn - CheckOut
 */
export const checkInOutErrorsManagement = (error: any): {mess: string, snBarType: snackbarTypes} => {
    let mess = '';
    let snBarType = snackbarTypes.error;

    if (error.response?.status === 400 &&
        [
            "\"ERROR_VEHICLE_NOT_INFLATED\"",
            "\"ERROR_PRICING_MISSING_CONFIGURATION\"",
            "\"ERROR_PRICING_BAD_CONFIGURATION\"",
            "\"ERROR_PRICING_NOT_SELLABLE\"",
            "\"ERROR_PRICING_NOT_CONFIGURED\"",
            "\"ERROR_CALLING_OPR_SERVICE\""
        ].includes(error.response?.data?.errorDetails)) 
    {
        switch (error.response?.data?.errorDetails) {
            case "\"ERROR_VEHICLE_NOT_INFLATED\"":
                mess = 'common.error.vehicleNotInflated';
                break;
            case "\"ERROR_PRICING_MISSING_CONFIGURATION\"":
                mess = 'common.error.pricingMissingConfiguration';
                break;
            case "\"ERROR_PRICING_BAD_CONFIGURATION\"":
                mess = 'common.error.pricingBadConfiguration';
                break;
            case "\"ERROR_PRICING_NOT_SELLABLE\"":
                mess = 'common.error.pricingNotSellable';
                snBarType = snackbarTypes.warning;
                break;
            case "\"ERROR_PRICING_NOT_CONFIGURED\"":
                mess = 'common.error.pricingNotConfigured';
                break;
            case "\"ERROR_CALLING_OPR_SERVICE\"":
                mess = 'common.error.callingOprService';
                break;
        }
    }

    if(!mess)
        mess = commonPricingIntegrationErrorsManagement(error) || 'translation:error.tryLater';

    return {
        mess,
        snBarType
    };
};